import React, { useRef } from 'react';
var VeltActivityLogHeaderTitle = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-activity-log-header-title", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltActivityLogHeaderTitle;
